import React, { Component } from "react";

class FieldSelect extends Component {
    render() {
        let { fieldConfig, schema } = this.props;

        return (
            <select {...fieldConfig}>
                <option />
                {"enum" in schema &&
                    schema.enum.map((enumVal, i) => {
                        return (
                            <option value={enumVal} key={enumVal}>
                                {"enumNames" in schema
                                    ? schema.enumNames[i]
                                    : enumVal}
                            </option>
                        );
                    })}
            </select>
        );
    }
}

export default FieldSelect;



// WEBPACK FOOTER //
// ./src/FieldSelect.js